const Arrow_SVG = ({color, ...props}) => {
	return (
			<svg width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
				<path d="M1.25 0h5v1.125h-5zM0 1.125h7.5v1.125h-7.5zM0 2.25h8.75v1.125h-8.75zM0 3.375h10v1.125h-10zM0 4.5h11.25v1.125h-11.25zM0 5.625h12.5v1.125h-12.5zM0 6.75h13.75v1.125h-13.75zM0 7.875h15v1.125h-15zM0 9h15v1.125h-15zM0 10.125h13.75v1.125h-13.75zM0 11.25h12.5v1.125h-12.5zM0 12.375h11.25v1.125h-11.25zM0 13.5h10v1.125h-10zM0 14.625h8.75v1.125h-8.75zM0 15.75h7.5v1.125h-7.5zM1.25 16.875h5v1.125h-5z" fill={color}/>
			</svg>
	)
}
export default Arrow_SVG